import Map, { type MapProps } from "./Map";
export { Map as default, Map, MapProps };